import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../_services/user.service';
@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router,
                private storageService: UserService) { }

    canActivate(next: ActivatedRouteSnapshot,
                state: RouterStateSnapshot) {
        if (this.storageService.isLogedIn()) {
            return true;
        }
        const idAplicacion = next.params.idAplicacion;
        const filtroAdicional = next.queryParams.filtroAdicional;
        const redirectUrl = next.queryParams.redirectUrl;
        this.router.navigate(['/login', idAplicacion], {
            queryParams:
            {
                filtroAdicional,
                redirectUrl
            }
        });
        return false;
    }
}
